import { Injectable } from '@angular/core';
import moment, { Moment } from 'moment';
import { CalendarFormat } from '../types/calendar.types';

export class CalendarData {
  constructor(public field: string, public data: any) {}
}

export class CalendarRow {
  constructor(public weekOf: string, public data: CalendarData[]) {}
}

@Injectable()
export class WeekSelectorService {
  private readonly rowsNumber = 5;
  private readonly columnsNumber = 7;

  public fetchWeeks(selectedMonth: Moment, weekdays = true): CalendarRow[] {
    const weeks = [];
    const weekend = ['sun', 'sat'];
    const allDays = this.fetchDays(selectedMonth);
    const columnsCount = weekdays ? this.columnsNumber - 2 : this.columnsNumber;
    const days = weekdays
      ? allDays.filter((day) => !weekend.some((d) => d === day.field))
      : allDays;
    for (let i = 0; i < this.rowsNumber; i++) {
      const row = days.slice(i * columnsCount, i * columnsCount + columnsCount);
      const weekOf = moment(row[0].data).day(1).format(CalendarFormat.ISO);
      weeks.push(new CalendarRow(weekOf, row));
    }

    return weeks;
  }

  private addDays(
    array: CalendarData[],
    arrayStart: number,
    date: Moment,
    month: number,
    daysInMonth: number,
    monthDateStart: number
  ): void {
    for (let i = 0; i < daysInMonth; i++) {
      const d = moment(date)
        .month(month)
        .date(monthDateStart + i + 1);
      array[arrayStart + i] = new CalendarData(
        d.format('ddd').toLowerCase(),
        d.format(CalendarFormat.ISO)
      );
    }
  }

  private fetchDays(date: Moment): CalendarData[] {
    const sheetSize = this.rowsNumber * this.columnsNumber;
    const sheet = [];
    const selectedMonth = date.month();
    const daysInSelectedMonth = date.daysInMonth();
    const firstSelectedMonthDay = moment(date).date(1).day();
    const daysInPreviousMonth = moment(
      moment(date)
        .month(selectedMonth - 1)
        .format(CalendarFormat.monthISO),
      CalendarFormat.monthISO
    ).daysInMonth();

    const startsOnSat: boolean = firstSelectedMonthDay === 6;
    const monthStartIndex: number = startsOnSat ? 0 : firstSelectedMonthDay;
    const monthDateStart = startsOnSat ? 1 : 0;

    this.addDays(
      sheet,
      monthStartIndex,
      date,
      selectedMonth,
      daysInSelectedMonth,
      monthDateStart
    );

    // If 1st day starts on Sat this week is excluded to use 5 rows in all cases
    if (!startsOnSat) {
      this.addDays(
        sheet,
        0,
        date,
        selectedMonth - 1,
        firstSelectedMonthDay,
        daysInPreviousMonth - firstSelectedMonthDay
      );
    }

    this.addDays(
      sheet,
      daysInSelectedMonth + monthStartIndex,
      date,
      selectedMonth + 1,
      sheetSize - daysInSelectedMonth - monthStartIndex,
      monthDateStart
    );

    return sheet;
  }
}
